import { render, staticRenderFns } from "./UninstallCautions.vue?vue&type=template&id=59bf02d4&scoped=true&"
import script from "./UninstallCautions.vue?vue&type=script&lang=js&"
export * from "./UninstallCautions.vue?vue&type=script&lang=js&"
import style0 from "./UninstallCautions.vue?vue&type=style&index=0&id=59bf02d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf02d4",
  null
  
)

export default component.exports